// @flow

import { logger } from './logger'

import { updateSubscriber } from './api/chatchampApi'

import { getQueryParams } from './url'

export function updateSubscriberAttributesFromQueryParams (customerId: string, subscriberId: string): void {
  const possibleAttributes = getQueryParams()
  updateSubscriber(customerId, subscriberId, possibleAttributes, { createAttributesIfNotExist: false }).then((subscriber) => {
    logger.info('Done updating subscriber attributes from query params')
    return subscriber
  }).catch((err) => {
    logger.error(`Error updating subscriber attributes from query params: ${err}`)
  })
}
